@if (!isFormCheck()) {
  <ng-container [ngTemplateOutlet]="labelTemplate" />
} @else if (!fieldset) {
  <!-- Empty spacer so the control aligns with the label column in form-col-layout. -->
  <div class="form-label"></div>
}
<div class="form-item-content">
  <ng-content />
  @if (isFormCheck()) {
    <ng-container [ngTemplateOutlet]="labelTemplate" />
  }
  @if (!isPartOfRadioGroup()) {
    <ng-container [ngTemplateOutlet]="feedbackTemplate" />
  }
</div>

<ng-template #labelTemplate>
  <div
    class="d-flex gap-2"
    [class.form-label]="!isFormCheck()"
    [class.form-check-label]="isFormCheck()"
  >
    @if (labelledby()) {
      <span [id]="labelledby()" [class.required]="showRequired()">{{ label() | translate }}</span>
    } @else {
      <label [for]="controlId()" [class.required]="showRequired()">{{ label() | translate }}</label>
    }
    <ng-content select="[si-help-button]" />
  </div>
</ng-template>

<ng-template #feedbackTemplate>
  <div class="invalid-feedback" [class.d-block]="errors().length" [attr.id]="errormessageId()">
    @for (error of errors(); track $index) {
      <div>
        {{ error.message ?? error.key | translate: error.params }}
      </div>
    }
  </div>
</ng-template>
